export * from './hooks/useAnalytics'; // main analytics hook + types
export * from './utils'; // utility functions
export type { PostHogEvent } from './types'; // event types
